import Vue from 'vue'
import {CONSTANTS_PROD, CONSTANTS_TEST, TEST_ENVIRONMENT} from '../../config/constants'
import axios from 'axios'
import {bus} from '../../components/Configuration/bus_configuration'

export var configuration_service = new Vue({
    data() {
        return {
            constants: {},
            full_url: ''
        }
    },
    methods: {
        async GetAllDiscounts() {
            await axios.get(this.full_url + 'discounts')
                .then(function (response) {
                    bus.GetAllDiscounts(response.data)
                })
                .catch(function (error) {
                    console.log(error);
                });

        },
        async CreateDiscount(data){
            await axios({
                method: 'POST',
                url: this.full_url + 'discounts',
                data: data
            })
                .then(function (response) {
                    bus.CreateDiscount(response.data)
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        async GetAllCategorys(){
            await axios.get(this.full_url + 'category')
                .then(function (response) {
                    bus.GetAllCategorys(response.data)
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        async CreateCategory(data){
            await axios({
                method: 'POST',
                url: this.full_url + 'category',
                data: data
            })
                .then(function (response) {
                    bus.CreateCategory(response.data)
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        async GetAllNotify() {
            await axios.get(this.full_url + 'notify')
                .then(function (response) {
                    bus.GetAllNotify(response.data)
                })
                .catch(function (error) {
                    console.log(error);
                });

        },
        async CreateNotify(data){
            await axios({
                method: 'POST',
                url: this.full_url + 'notify',
                data: data
            })
                .then(function (response) {
                    bus.CreateNotify(response.data)
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        async DeleteNotify(notify_id){
            await axios.delete(this.full_url + 'notify/'+notify_id)
                .then(function (response) {
                    bus.DeleteNotify(response.data)
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        async create_indice(index){
            await axios.get(this.full_url +index+'/index/create')
                .then(function (response) {
                    bus.create_indice(response.data)
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        async update_indice(index){
            await axios.get(this.full_url +index+'/index/update')
                .then(function (response) {
                    bus.update_indice(response.data)
                })
                .catch(function (error) {
                    console.log(error);
                });
        }
    },
    created() {
        (TEST_ENVIRONMENT) ? this.constans = CONSTANTS_TEST : this.constans = CONSTANTS_PROD;
        this.full_url = this.constans.URL_API + this.constans.VERSION_API;
    }
})